module.exports = __webpack_public_path__ + "media/images/homepage/hero_old-8cc15f68df3ba9f15d01a6c46538152f.png";